import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// admin_master administra a plataforma (não pertence a nenhuma empresa
// cliente) e nunca deve cair na área operacional de tenant — sua home é a
// área de Administração. Todo outro perfil continua indo para /clientes,
// como já era o comportamento antes do Admin Master existir.
// Exportada (Fluxo de Primeiro Acesso) — reaproveitada por PrimeiroAcesso.jsx
// para saber para onde mandar o usuário depois da troca de senha, sem
// duplicar a regra em dois lugares.
export const roleHome = (role) => (role === "admin_master" ? "/admin/empresas" : "/clientes");

export default function ProtectedRoute({ children, roles, feature }) {
  const { user, hasFeature } = useAuth();
  const location = useLocation();
  if (user === null) return (
    <div className="min-h-screen flex items-center justify-center text-slate-500">Carregando...</div>
  );
  if (user === false) return <Navigate to="/login" replace />;
  // Fluxo de Primeiro Acesso — nenhuma rota protegida (tenant OU Admin
  // Master) é acessível enquanto a senha provisória não for trocada, mesmo
  // por link direto/digitado na URL (não é só um redirecionamento pós-login;
  // roda em toda navegação, porque ProtectedRoute reavalia a cada render).
  // O backend já bloqueia de verdade (H5-003-01) — isto é só a experiência
  // correta para não deixar a tela operacional "piscar" antes do 403.
  // Verificação por Código: antes de "Defina sua nova senha" precisa passar
  // por "Verifique seu e-mail" — otp_verified vem de GET /auth/me.
  if (user.must_change_password) return <Navigate to={user.otp_verified ? "/primeiro-acesso" : "/verificar-codigo"} replace />;
  // Pacote consolidado pós-homologação, Prioridade 14 — bloqueio financeiro
  // (mensalidade LOOTUS vencida há mais de 15 dias corridos, sem pagamento
  // confirmado). Mesmo mecanismo do must_change_password acima (reavalia a
  // cada navegação, é só a experiência — o backend já bloqueia de verdade
  // via FINANCIAL_BLOCK_ALLOWED_PATHS/PREFIXES em server.py). Admin Master
  // nunca é afetado (financially_blocked só existe no objeto do usuário do
  // tenant). Único destino sempre permitido: /financeiro (a própria tela
  // onde o tenant regulariza o pagamento — ver Financeiro.jsx).
  if (user.financially_blocked && location.pathname !== "/financeiro") return <Navigate to="/financeiro" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={roleHome(user.role)} replace />;
  // NFS-e como recurso comercial (delta 2026-09-15) — `feature` é o
  // equivalente de rota para o mesmo hasFeature() já usado para
  // esconder/mostrar menu e abas (ver Layout.jsx/Configuracoes.jsx). Uma
  // URL direta para uma tela sem o recurso contratado cai aqui e é
  // redirecionada, mesmo padrão silencioso já usado acima para `roles` —
  // o backend é sempre a barreira real (require_feature nos endpoints).
  if (feature && !hasFeature(feature)) return <Navigate to={roleHome(user.role)} replace />;
  return children;
}
